import React, { useState } from 'react';


const PREVIOUS_QUESTIONS = [
    {
        question: 'What is the difference between a function and a method?',
        answer: 'A method is a function that is a property of an object.',
    },
    {
        question: 'What is the difference between a function and a method?',
        answer: 'A method is a function that is a property of an object.',
    }
];


function QuestionModal({setShowQuestionModal}) {
  const [currentQuestion, setCurrentQuestion] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(currentQuestion);
    setCurrentQuestion('');
    setShowQuestionModal(false);
  };

  const renderPreviousQuestions = () => {
    // shows question and expandable answer
    return PREVIOUS_QUESTIONS.map((question, index) => (
        <div className="my-4 border p-2" key={index}>
            <div className="font-medium text-sm text-gray-900">{question.question}</div>
            <div className="text-gray-700 text-sm">{question.answer}</div>
        </div>
    ));
    };


  return (
    <div className="relative z-50">
        <div className="fixed top-0 left-0 h-full w-full bg-gray-900 bg-opacity-75">
          <div className="p-4 m-auto max-w-sm bg-white rounded shadow-lg mt-20">
            <h1 className="text-lg font-medium text-gray-900">Previous Questions</h1>
            {renderPreviousQuestions()}
            <h1 className="text-lg font-medium text-gray-900">Ask a New Question</h1>

            <form onSubmit={handleSubmit}>
              <div className="my-4">
                <textarea
                  className="w-full p-2 border border-gray-400 rounded"
                  id="question"
                  type="textarea"
                  value={currentQuestion}
                  onChange={(e) => setCurrentQuestion(e.target.value)}
                />
              </div>
              <div className="flex justify-end">
                <button
                  className="bg-gradient-to-r from-indigo-500 to-purple-500 hover:bg-blue-700 text-white hover:from-indigo-700 hover:to-purple-700 font-bold py-2 px-4 rounded mr-2"
                  type="submit"
                >
                  Submit with EdStem
                </button>
                <button
                  className="border-red-500 border hover:bg-red-50 text-red-500 font-bold py-2 px-4 rounded"
                  onClick={() => setShowQuestionModal(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
    </div>
  );
};

export default QuestionModal;
